import { render, staticRenderFns } from "./CrewAspView.vue?vue&type=template&id=2c44038a"
import script from "./CrewAspView.vue?vue&type=script&lang=js"
export * from "./CrewAspView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports